import { useEffect, useState } from "react";
import { api } from "@/context/AuthContext";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Package, TrendingUp, ArrowRight } from "lucide-react";

const RANK = ["bg-amber-400 text-white", "bg-slate-300 text-slate-800", "bg-orange-300 text-orange-900"];

export default function LowStockCard({ canConsumable, onNavigate }) {
  const [data, setData] = useState({ hari: 365, items: [] });
  useEffect(() => { if (canConsumable) api.get("/barang/sering-digunakan").then((res) => setData(res.data)).catch(() => {}); }, [canConsumable]);
  if (!canConsumable || data.items.length === 0) return null;
  const maxQ = data.items[0]?.keluar_periode || 1;
  return (
    <Card className="p-6 border-teal-200 bg-teal-50/40 shadow-none rounded-lg" data-testid="sering-digunakan-card">
      <div className="flex items-center gap-2 mb-4">
        <button onClick={() => onNavigate?.("barang")} data-testid="goto-barang" className="flex items-center gap-2 group" title="Buka modul Consumable">
          <Package className="h-4 w-4 text-teal-600" />
          <h3 className="text-base font-semibold text-slate-900 group-hover:text-teal-600 transition-colors">Barang Sering Digunakan</h3>
          <ArrowRight className="h-3.5 w-3.5 text-slate-300 group-hover:text-teal-600 group-hover:translate-x-0.5 transition-all" />
        </button>
        <Badge className="bg-teal-100 text-teal-700 hover:bg-teal-100">1 tahun terakhir</Badge>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3" data-testid="sering-digunakan-list">
        {data.items.map((b, i) => (
          <div key={b.id} data-testid={`sering-item-${b.kode}`} className="rounded-lg border border-teal-200 bg-white p-3 flex items-center gap-3">
            <div className={`h-9 w-9 rounded-lg flex items-center justify-center shrink-0 text-sm font-black ${RANK[i] || "bg-teal-100 text-teal-700"}`}>{i + 1}</div>
            <div className="min-w-0 flex-1">
              <p className="text-sm font-semibold text-slate-900 truncate">{b.nama}</p>
              <p className="text-xs text-slate-500 truncate">{b.kode}{b.jenis ? ` · ${b.jenis}` : ""} · {b.keluar_transaksi}× diambil</p>
              <div className="mt-1 flex items-center gap-2">
                <div className="h-1.5 flex-1 rounded-full bg-teal-100"><div className="h-full rounded-full bg-teal-500" style={{ width: `${Math.max(6, (b.keluar_periode / maxQ) * 100)}%` }} /></div>
                <span className="text-xs font-bold text-teal-700 tabular-nums inline-flex items-center gap-0.5"><TrendingUp className="h-3 w-3" />{b.keluar_periode}{b.satuan ? ` ${b.satuan}` : ""}</span>
              </div>
              <p className={`text-[11px] mt-0.5 ${b.menipis ? "text-rose-600 font-semibold" : "text-slate-400"}`}>Sisa stok {b.stok_akhir}{b.satuan ? ` ${b.satuan}` : ""}{b.menipis ? " · menipis" : ""}</p>
            </div>
          </div>
        ))}
      </div>
    </Card>
  );
}
